import { JSX }		from "preact";

import { Dom }					from "ts-base/web/dom";

import { DecoratedProps }		from "@v3/geko/Decorated";
import { Decor, DecorProps }	from "@v3/geko/Decor";

export type ExternalLinkProps	=
	DecoratedProps	&
	Readonly<{
		href:			string,
	}> &
	DecorProps;

export const ExternalLink	= (props:ExternalLinkProps):JSX.Element	=> {
	const { href, customClass }	= props;

	return (
		<a
			class={Dom.classes(
				"ExternalLink",
				"Decorated",
				"interactive",
				customClass
			)}
			href={href}
			target="_blank"
		>
			<Decor {...props}/>
		</a>
	);
};
